import { Suspense } from 'react';
import { defaultTotal } from '../../components/Stripe/RegistrationCheckoutForm';
import axios from 'axios';
import { QueryBuilder } from '@material-ui/icons';

export const BASE_URL = process.env.REACT_APP_VIRTUALASSISSTANT_API_ADDRESS;
export const API_BASE_URL = BASE_URL + '/api';
let ownerSubscriptionsRequest = null;
let ownerInvoicesRequest = null;

const getProducts = async () => {
  try {
    const config = {
      method: 'GET',
      url: `${API_BASE_URL}/products`,
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const response = await axios(config);
    const { status } = response;

    if (status !== 200) {
      return [];
    }

    const { data } = response;
    return data;
  } catch (error) {
    throw error;
  }
};

const postSubscription = async (priceIds, coupons, extraCertificates) => {
  try {
    const authToken = localStorage.getItem('authToken');

    const config = {
      method: 'POST',
      url: `${API_BASE_URL}/subscriptions`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
      data: {
        PriceIds: priceIds,
        Coupons: coupons,
        Quantity: extraCertificates,
      },
    };

    const response = await axios(config);
    const { status } = response;
    if (status !== 200) {
      const { statusText } = response;
      return statusText;
    }

    const { data } = response;
    return { clientSecret: data.clientSecret, requiresPayment: data.requiresPayment ?? false };
  } catch (error) {
    throw error;
  }
};

const retryInvoice = async (invoiceId, paymentMethodId) => {
  try {
    const authToken = localStorage.getItem('authToken');

    const config = {
      method: 'POST',
      url: `${API_BASE_URL}/invoices/retryinvoice`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
      data: {
        InvoiceId: invoiceId,
        PaymentMethodId: paymentMethodId,
      },
    };

    const response = await axios(config);

    const { status } = response;
    if (status !== 200) {
      const { statusText } = response;
      return statusText;
    }

    return response;
  } catch (error) {
    throw error;
  }
};

const updateBillingInfo = async (billingInfo) => {
  try {
    const authToken = localStorage.getItem('authToken');

    const config = {
      method: 'PUT',
      url: `${API_BASE_URL}/customers/updateuserbillingaddress`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
      data: {
        User_City: billingInfo.paymentCity,
        User_Country: billingInfo.paymentCountry,
        User_Line1: billingInfo.paymentAddress,
        User_PostalCode: billingInfo.paymentZIP,
        User_State: billingInfo.paymentState,
      },
    };

    const response = await axios(config);

    const { status } = response;
    if (status !== 200) {
      const { statusText } = response;
      return statusText;
    }

    return response?.data;
  } catch (error) {
    throw error;
  }
};

// const getPreviewInvoice = async (prices, previewCoupons, quantity) => {
//   try {
//     const authToken = localStorage.getItem('authToken');
//     const config = {
//       method: 'POST',
//       url: `${API_BASE_URL}/invoices/invoicepreview`,
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${authToken}`,
//       },
//       data: {
//         Prices: prices,
//         Coupons: previewCoupons,
//         Quantity: quantity,
//       },
//     };

//     const response = await axios(config);
//     const { status } = response;

//     if (status !== 200) {
//       return { invoicesData: [], totalData: defaultTotal, status: 400 };
//     }

//     const { data: invoicesData } = response;
//     const { StripeInvoiceLineItems } = invoicesData;

//     const coupons = Array.isArray(invoicesData?.Coupons) ? invoicesData.Coupons : [];

//     const generalIdx = coupons.findIndex(c => Number(c?.CouponType) === 4);
//     const generalExists = generalIdx !== -1;
//     const generalCoupon = generalExists ? coupons[generalIdx] : null;

//     const otherCouponIndices = coupons.map((_, i) => i).filter(i => i !== generalIdx);
//     const otherCoupons = otherCouponIndices.map(i => coupons[i]);

//     let generalDiscountTotal = 0;
//     const otherDiscountTotals = new Array(otherCoupons.length).fill(0);

//     const invoices = (StripeInvoiceLineItems || []).map((item) => {
//       const amount = item.Amount;
//       const currency = item.Currency;
//       const description = item.Description;

//       const taxes = (item.TaxAmounts || []).reduce(
//         (sum, t) => sum + (t?.Amount || 0),
//         0
//       );

//       const discountAmounts = Array.isArray(item.DiscountAmounts) ? item.DiscountAmounts : [];
//       const dLen = discountAmounts.length;

//       const discounts = discountAmounts.reduce(
//         (sum, d) => sum + (d?.DiscountAmount || 0),
//         0
//       );

//       let generalDiscount = 0;
//       const otherDiscounts = new Array(otherCoupons.length).fill(0);

//       if (generalExists && dLen >= 1) {
//         const genDIdx = dLen - 1;
//         generalDiscount = discountAmounts[genDIdx]?.DiscountAmount || 0;

//         otherCouponIndices.forEach((couponIdx, k) => {
//           const dIdx = k < genDIdx ? k : null;
//           if (dIdx != null) {
//             const v = discountAmounts[dIdx]?.DiscountAmount || 0;
//             otherDiscounts[k] = v;
//           }
//         });
//       } else {
//         otherCouponIndices.forEach((couponIdx, k) => {
//           const dIdx = couponIdx < dLen ? couponIdx : null;
//           if (dIdx != null) {
//             const v = discountAmounts[dIdx]?.DiscountAmount || 0;
//             otherDiscounts[k] = v;
//           }
//         });
//       }

//       generalDiscountTotal += generalDiscount;
//       otherDiscounts.forEach((v, k) => { otherDiscountTotals[k] += v; });

//       return {
//         amount,
//         description,
//         currency,
//         taxes,
//         discounts,
//         generalDiscount,
//         otherDiscounts,
//       };
//     });

//     const { Subtotal: subtotal } = invoicesData;
//     const { TotalDiscountAmount: totalDiscount } = invoicesData;
//     const { Tax: tax } = invoicesData;
//     const { Total: total } = invoicesData;
//     const { IsCouponDisabled: isCouponDisabled } = invoicesData;

//     return {
//       invoicesData: invoices,
//       totalData: {
//         subtotal,
//         totalDiscount,
//         tax,
//         total,
//         coupons,
//         generalCoupon,
//         otherCoupons,
//         generalDiscountTotal,
//         otherDiscountTotals,
//         isCouponDisabled,
//       },
//       status: 200,
//     };
//   } catch (error) {
//     if (error?.response?.status === 422) {
//       return { invoicesData: [], totalData: defaultTotal, status: 422 };
//     }
//     throw error;
//   }
// };

const getPreviewInvoice = async (prices, previewCoupons, quantity) => {
  try {
    const authToken = localStorage.getItem('authToken');
    const config = {
      method: 'POST',
      url: `${API_BASE_URL}/invoices/invoicepreview`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
      data: {
        Prices: prices,
        Coupons: previewCoupons,
        Quantity: quantity,
      },
    };

    const response = await axios(config);
    if (response.status !== 200) {
      const errorMessage = response.data?.Message ?? response.data ?? null;
      return { invoicesData: [], totalData: defaultTotal, status: response.status, errorMessage };
    }

    const invoicesData = response.data;
    const { StripeInvoiceLineItems } = invoicesData;
    const coupons = Array.isArray(invoicesData?.Coupons) ? invoicesData.Coupons : [];
    const { TrialDays: trialDays, ForceProration: forceProration } = invoicesData;
    const generalIdx = coupons.findIndex(c => Number(c?.CouponType) === 4);
    const generalExists = generalIdx !== -1;
    const generalCoupon = generalExists ? coupons[generalIdx] : null;
    const otherCoupons = coupons.filter((_, i) => i !== generalIdx);

    let generalDiscountTotal = 0;
    const otherDiscountTotals = new Array(otherCoupons.length).fill(0);

    const invoices = (StripeInvoiceLineItems || []).map((item) => {
      const amount = item.Amount;
      const currency = item.Currency;
      const description = item.Description;

      const taxes = (item.TaxAmounts || []).reduce(
        (sum, t) => sum + (t?.Amount || 0),
        0
      );

      const discountAmounts = Array.isArray(item.DiscountAmounts) ? item.DiscountAmounts : [];
      const discounts = discountAmounts.reduce(
        (sum, d) => sum + (d?.DiscountAmount || 0),
        0
      );

      let generalDiscount = 0;
      const otherDiscounts = new Array(otherCoupons.length).fill(0);

      if (generalExists && discountAmounts.length > 0) {
        const genDIdx = discountAmounts.length - 1;
        generalDiscount = discountAmounts[genDIdx]?.DiscountAmount || 0;

        for (let k = 0; k < otherCoupons.length; k++) {
          if (k < genDIdx) {
            otherDiscounts[k] = discountAmounts[k]?.DiscountAmount || 0;
          }
        }
      } else {
        for (let k = 0; k < otherCoupons.length; k++) {
          if (k < discountAmounts.length) {
            otherDiscounts[k] = discountAmounts[k]?.DiscountAmount || 0;
          }
        }
      }

      generalDiscountTotal += generalDiscount;
      otherDiscounts.forEach((v, k) => { otherDiscountTotals[k] += v; });

      return {
        amount,
        description,
        currency,
        taxes,
        discounts,
        generalDiscount,
        otherDiscounts,
      };
    });

    return {
      invoicesData: invoices,
      totalData: {
        subtotal: invoicesData.Subtotal,
        totalDiscount: invoicesData.TotalDiscountAmount,
        tax: invoicesData.Tax,
        total: invoicesData.Total,
        coupons,
        generalCoupon,
        otherCoupons,
        generalDiscountTotal,
        otherDiscountTotals,
        isCouponDisabled: invoicesData.IsCouponDisabled,
        trialDays: trialDays,
        forceProration: forceProration ?? false,
      },
      status: 200,
    };
  } catch (error) {
    const status = error?.response?.status ?? 500;
    const message = error?.response?.data?.Message ?? error?.response?.data ?? null;
    return { invoicesData: [], totalData: defaultTotal, status, errorMessage: message };
  }
};
const dataForAdminClientTable = (adminClients) => {
  return adminClients.map((adminClient) => ({
    username: adminClient.UserName,
    firstName: adminClient.FirstName,
    lastName: adminClient.LastName,
    companyName: adminClient.CompanyName,
    confirmationDate: adminClient.ConfirmationDate,
    postalCode: adminClient.UserAddress?.Postal_Code,
    active: adminClient.Active,
    userId: adminClient.UserId,
    status: adminClient.Status,
  }));
};

const dataForSubscriptionTable = (subscriptions) => {
  const result = [];

  (subscriptions || []).forEach((subscription) => {
    const subscriptionObject = {};
    Object.assign(subscriptionObject, {
      companyId: subscription.CompanyID,
      fullName: subscription.UserFullName,
      status: subscription.Status,
      periodEnd: subscription.CurrentPeriodEnd,
    });
    const products = Array.isArray(subscription?.StripeSubscriptionItems)
      ? subscription.StripeSubscriptionItems
      : [];

    products.forEach((product) => {
      const productObject = {};
      Object.assign(productObject, {
        total: product.UnitAmount,
        subscriptionName: product.ProductName,
      });

      const resultObject = {};
      Object.assign(resultObject, subscriptionObject);
      Object.assign(resultObject, productObject);

      result.push(resultObject);
    });
  });
  return result;
};

const dataForInvoiceTable = (invoices) => {
  const tempInvoices = [];
  for (const invoice of invoices) {
    const duplicate = tempInvoices.filter(
      (tempInvoice) => tempInvoice.InvoiceId === invoice.InvoiceId
    )[0];

    if (!duplicate) {
      tempInvoices.push(invoice);
    } else {
      invoice.Status = 'failed';
      tempInvoices.push(invoice);
    }
  }

  return tempInvoices.map((invoice) => ({
    id: invoice.InvoiceId,
    userId: invoice.UserId,
    customerName: invoice.CustomerName,
    status: invoice.Status,
    number: invoice.Number,
    ammountDue: invoice.AmountDue,
    ammountRemaining: invoice.AmountRemaining,
    pdf: invoice.InvoicePdf,
  }));
};

const getAllAdminSubscriptions = async (take, page, status) => {
  try {
    const authToken = localStorage.getItem('authToken');

    const config = {
      method: 'GET',
      url: `${API_BASE_URL}/subscriptions/getallsubscriptions`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
      params: {
        take,
        page,
        status,
      },
    };

    const response = await axios(config);

    if (response.status === 200) {
      const { data } = response;
      const result = dataForSubscriptionTable(
        data.filter((activeSub) => activeSub.Status === 'active')
      );
      return result;
    }

    return [];
  } catch (error) {
    throw error;
  }
};

const adminInvoiceUser = async (userId, take, page) => {
  try {
    const authToken = localStorage.getItem('authToken');

    const config = {
      method: 'GET',
      url: `${API_BASE_URL}/invoices/admininvoicesuser`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
      params: {
        userId,
        take,
        page,
      },
    };

    const response = await axios(config);

    if (response.status === 200) {
      const data = response.data;
      const result = dataForInvoiceTable(data.Items);
      return result;
    }

    return [];
  } catch (error) {
    throw error;
  }
};

const adminSubscriptionsUser = async (userId, take, page) => {
  try {
    const authToken = localStorage.getItem('authToken');

    const config = {
      method: 'GET',
      url: `${API_BASE_URL}/subscriptions/getallsubscriptions`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
      params: {
        userId,
        take,
        page,
      },
    };

    const response = await axios(config);

    if (response.status === 200) {
      const data = response.data;
      const result = dataForSubscriptionTable(data);
      return result;
    }

    return [];
  } catch (error) {
    throw error;
  }
};

const getAllregisteredAdminClients = async (take, page, searchTerm) => {
  try {
    const authToken = localStorage.getItem('authToken');

    const config = {
      method: 'GET',
      url: `${API_BASE_URL}/User/GetAllRegisteredAdminClients`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
      params: {
        take,
        page,
        searchTerm,
      },
    };

    const response = await axios(config);

    if (response.status === 200) {
      const data = response.data;
      const result = dataForAdminClientTable(data.Items);
      return result;
    }

    return [];
  } catch (error) {
    throw error;
  }
};

const getOwnerSubscriptions = (subscriptions) => {
  const result = [];
  (subscriptions || []).forEach((subscription) => {
    const subscriptionObject = {};
    Object.assign(subscriptionObject, {
      subscriptionId: subscription.SubscriptionId,
      periodStart: subscription.CurrentPeriodStart,
      periodEnd: subscription.CurrentPeriodEnd,
      cancelAt: subscription.CancelAt,
      canceledAtPeriodEnd: subscription.CanceledAtPeriodEnd,
      subscriptionTotalAmount: subscription.TotalAmount,
      subscriptionAppliedDiscount: subscription.AppliedDiscount,
      subscriptionCoupon: subscription.Coupon,
      subscriptionCouponTypeId: subscription.CouponTypeId
    });
    const products = Array.isArray(subscription?.StripeSubscriptionItems)
      ? subscription.StripeSubscriptionItems
      : [];

    products.forEach((product) => {
      const productObject = {};
      Object.assign(productObject, {
        currency: product.Currency,
        priceId: product.PriceId,
        productId: product.ProductId,
        productAppType: product.ProductAppType,
        amount: product.UnitAmount,
        subscriptionName: product.ProductName,
        subscriptionItemId: product.StripeSubscriptionItemId,
        productName: product.ProductName,
        productUserCount: product.ProductUserCount,
        service: product.ProductAppType === '2',
        coupon: product.Coupon,
        appliedDiscount: product.AppliedDiscount,
        afterDiscountPrice: product.AfterDiscountPrice,
        couponTypeId: product.CouponTypeId,
        taxAmount: product.TaxAmount,
      });

      const resultObject = {};
      Object.assign(resultObject, subscriptionObject);
      Object.assign(resultObject, productObject);
      result.push(resultObject);
    });
  });

  return result;
};

const ownerSubscriptions = async () => {
  if (ownerSubscriptionsRequest) return ownerSubscriptionsRequest;

  ownerSubscriptionsRequest = (async () => {
    const authToken = localStorage.getItem('authToken');

    const config = {
      method: 'GET',
      url: `${API_BASE_URL}/subscriptions`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
    };

    const response = await axios(config);
    if (response.status === 200) {
      let subscriptions = Array.isArray(response.data)
        ? response.data
        : response.data ? [response.data] : [];
      return getOwnerSubscriptions(
        subscriptions.filter((s) => s.Status !== 'false')
      );
    }

    return [];
  })();

  try {
    return await ownerSubscriptionsRequest;
  } finally {
    ownerSubscriptionsRequest = null;
  }
};

const ownerInvoices = async () => {
  if (ownerInvoicesRequest) return ownerInvoicesRequest;

  ownerInvoicesRequest = (async () => {
    const authToken = localStorage.getItem('authToken');

    const config = {
      method: 'GET',
      url: `${API_BASE_URL}/invoices`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
    };

    const response = await axios(config);
    if (response.status === 200) {
      const { data } = response;
      const { Items, TotalCount } = data;
      return {
        totalCount: TotalCount,
        invoicesArray: dataForInvoiceTable(Items),
      };
    }

    return [];
  })();

  try {
    return await ownerInvoicesRequest;
  } finally {
    ownerInvoicesRequest = null;
  }
};

const checkToken = async (token) => {
  try {
    const config = {
      method: 'POST',
      url: `${API_BASE_URL}/ValidateRegistrationLink`,
      data: { Token: token },
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const response = await axios(config);

    if (response.status === 200) {
      const { data } = response;
      return data;
    }

    return response;
  } catch (error) {
    throw error;
  }
};

export {
  getProducts,
  postSubscription,
  getPreviewInvoice,
  getAllAdminSubscriptions,
  adminInvoiceUser,
  adminSubscriptionsUser,
  getAllregisteredAdminClients,
  ownerSubscriptions,
  ownerInvoices,
  retryInvoice,
  updateBillingInfo,
  checkToken,
};
